import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  keyword: faker.internet.email,
  reason: faker.lorem.paragraph,
  createdBy: () => `created by ${faker.person.fullName()}`,
  photo: () => {
    if (faker.datatype.boolean()) {
      const url = faker.image.avatar();
      return {
        thumb: url,
        original: url,
      };
    }
  },
  fullName: faker.person.fullName(),
  aliases() {
    return [faker.person.firstName(), faker.person.firstName()];
  },
  otherKeywords: faker.lorem.sentence().split(' '),
});
